import React, { FC, RefObject, useCallback, useState } from 'react'
import styles from 'styles/components/header.module.scss'
import print from 'styles/components/print.module.scss'
import { HeaderLogo, HeaderMenuButton, HeaderMenuBack, HeaderNavBackground, HeaderNavMenu } from 'components/Header'
import { useFixedBackface } from 'hooks/effect'
import { useSelector } from 'react-redux'
import { State } from 'index'

type Props = {
  headingRef?: RefObject<HTMLHeadingElement>
  isPrintLayout?: boolean
}

const Header: FC<Props> = (props) => {
  const { headingRef, isPrintLayout } = props
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const [open, setOpen] = useState<boolean>(false)
  const handleMenuToggle = useCallback(() => setOpen((prevState) => !prevState), [setOpen])
  const handleMenuClose = useCallback(() => setOpen(false), [setOpen])

  // メニューOPEN時に背景を固定する（スクロールを禁止する）
  useFixedBackface(open, [open])

  return (
    <header
      className={open ? `${styles.header} ${styles.open} ${print.screenArea}` : `${styles.header} ${print.screenArea}`}
    >
      <div className={isPrintLayout ? styles.header__inner_print : styles.header__inner}>
        {pathname !== '/' && <HeaderMenuBack />}
        <HeaderLogo headingRef={headingRef} />
        <HeaderMenuButton handleMenuToggle={handleMenuToggle} />
      </div>
      <HeaderNavMenu handleMenuClose={handleMenuClose} />
      <HeaderNavBackground handleMenuClose={handleMenuClose} />
    </header>
  )
}

export default Header
